// eslint-disable-next-line import/no-anonymous-default-export
export default (history, pathname) => (state) => {
  history.push({
    pathname,
    state,
  });
};